var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { FieldBorder, HelperText } from "./";
import FloatLabel from "./FloatLabel";
import Box from "../../box/Box";
function Field(_a, ref) {
    var fieldState = _a.fieldState, children = _a.children, helperText = _a.helperText, label = _a.label, error = _a.error, icon = _a.icon, boxProps = _a.boxProps, htmlFor = _a.htmlFor;
    var bg = boxProps.bg, otherBoxProps = __rest(boxProps, ["bg"]);
    var doShrink = fieldState.hasValue || fieldState.focused;
    var defaultBoxProps = {
        my: 2,
    };
    return (React.createElement(Box, __assign({ ref: ref }, __assign(__assign({}, defaultBoxProps), otherBoxProps)),
        React.createElement(FieldBorder, { fieldState: fieldState, bg: bg },
            label && (React.createElement(FloatLabel, { htmlFor: htmlFor, doShrink: doShrink }, label)),
            children,
            icon && (React.createElement(Box, { width: "57px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", style: {
                    position: "absolute",
                    right: 0,
                    top: 0,
                    zIndex: 2,
                } }, icon))),
        error || helperText ? (React.createElement(HelperText, { id: htmlFor + "__helper-text", fieldState: fieldState }, error ? error : helperText)) : null));
}
export default React.forwardRef(Field);
//# sourceMappingURL=Field.js.map